import { combineReducers } from '@reduxjs/toolkit'

import { markerNamesByFieldReducer } from './markerNamesByFields'
import { wellsByFieldReducer } from './wellsByFields'

export const hotStorageReducer = combineReducers({
  wellsByFields: wellsByFieldReducer,
  markerNamesByFields: markerNamesByFieldReducer,
})
